/* =============================================
   Sidebar Navigation — collapsible levels
   Default state: fully expanded (markup renders
   aria-expanded="true" and visible submenus).
   ============================================= */
(function () {
  var ANIMATION_MS = 200; // keep in sync with CSS height transition

  function collapse(button, target) {
    button.setAttribute('aria-expanded', 'false');
    // Freeze current height, then animate to 0
    target.style.height = target.scrollHeight + 'px';
    requestAnimationFrame(function () {
      target.style.height = '0px';
    });
    window.setTimeout(function () {
      target.hidden = true;
      target.style.height = '';
    }, ANIMATION_MS + 30);
  }

  function expand(button, target) {
    button.setAttribute('aria-expanded', 'true');
    target.hidden = false;
    // Start from 0, then animate to natural height
    target.style.height = '0px';
    requestAnimationFrame(function () {
      target.style.height = target.scrollHeight + 'px';
    });
    window.setTimeout(function () {
      target.style.height = '';
    }, ANIMATION_MS + 30);
  }

  function initSidebarNav() {
    var buttons = document.querySelectorAll('.sidebar-nav__toggle');
    buttons.forEach(function (button) {
      if (button.dataset.sidebarToggleInit === 'true') return;
      button.dataset.sidebarToggleInit = 'true';

      var targetId = button.getAttribute('aria-controls');
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      button.addEventListener('click', function () {
        var isExpanded = button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          collapse(button, target);
        } else {
          expand(button, target);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebarNav);
  } else {
    initSidebarNav();
  }
})();
